<template>
  <div data-test-path="mobile-menu" ref="root" tabindex="0" @focusout="onFocusLost" @keydown="onKeyDown">
    <transition name="fade">
      <div class="shadow bg-light-shade" v-show="localVisible" style="width: 280px">

        <div class="sidebar-sticky pt-0 w-100">

          <div class="pt-0 pl-0 pr-0 accordion" role="tablist">
            <MenuItems id-prefix="mobile" type="mobile-menu" :openedItem.sync="defaultOpenedItem"></MenuItems>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

// import {getLeftMenu} from "@/components/dashboard/menu/MenuContent";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
// import SubMenu from "@/components/dashboard/menu/SubMenu";
import StickyNote from "@/server/com/silkplm/model/sticky/StickyNote";
import ServerEvents from "@/server/ServerEvents";
import MenuItems from "@/components/dashboard/menu/MenuItems";

// !!!!!!!!! To jest menu mobilne, drugie menu znajduje się w pliku DesktopMenu

export default {
  name: "LeftMenu",
  components: {MenuItems},
  mounted() {
  },
  created() {
    this.self = this;
    EventBus.$on('openMainMenu', () => {
      this.show();
    });
  },
  // async beforeMount() {
  //   this.menu = await getLeftMenu();
  //   this.menuLoading = false;
  //   this.$onEvent(Events.menuUpdated, async () => {
  //     this.menu = await getLeftMenu();
  //   });
  //   this.localVisible = this.visible;
  //
  //   this.$onEvent(ServerEvents.formsChange, async () => {
  //     this.menu = await getLeftMenu();
  //   });
  // },
  methods: {
    onFocusLost(/** FocusEvent*/ focusEvent) {
      let el = focusEvent.relatedTarget;
      while (el) {
        if (el === this.$el || el.id === "left-menu-toggle-button") {
          return;
        }
        el = el.parentElement;
      }
      this.hide();
    },
    onKeyDown(ev) {
      let key = ev.keyCode || ev.charCode;

      if (key == 27) {
        this.hide();
      }
    },
    checkFocus() {
      let el = document.activeElement;
      while (el) {
        if (el === this.$el || el.id === "left-menu-toggle-button") {
          return;
        }
        el = el.parentElement;
      }
      this.hide();
    },
    toggle() {
      if (this.localVisible) {
        this.hide();
      } else {
        this.show();
      }
    },
    hide() {
      this.localVisible = false; // do ukrycia menu
      this.$emit("toggle", this.localVisible);
    },
    show() {
      this.localVisible = true;
      this.$emit("toggle", this.localVisible);
      this.$refs?.root?.focus();
    },

    execute(menuItem) {
      if (menuItem.action) {
        Rpc.Interactions.event("left-menu", {name: menuItem.id}).then();
        menuItem.action();
      }
      this.hide();
    },

    closeSubMenu(subMenu, idToKeep) {
      if (!subMenu.items) {
        return;
      }
      let itemFound = false;
      for (let item of subMenu.items) {
        itemFound = this.closeSubMenu(item, idToKeep) || itemFound;
      }
      if (itemFound) {
        return true;
      }
      if (subMenu.id === idToKeep) {
        return true;
      } else {
        if(subMenu.open){
          subMenu.open = false;
        }
      }
    },


    closeOtherSubMenus(section, parent) {
      for(let subMenu of this.$refs.subMenu){
        subMenu.closeSubMenu(section.id);
      }
    },
  },
  props: {
    visible: false
  },
  model: {
    prop: 'visible',
    event: 'toggle'
  },
  data: function () {
    return {
      localVisible: false,
      menuLoading: true,
      menu: [],
      self: null,
      defaultOpenedItem: 'plm'  //null, 'plm', 'dict', etc.
    }
  }
}
</script>

<style lang="sass" scoped>

.no-glow:focus
  outline: 0 !important
  box-shadow: 0 0 0 0 !important
  border: none !important
  border-radius: unset !important

.no-glow
  box-shadow: 0 0 0 0 !important
  border: none !important
  border-radius: unset !important

.card-header, .btn
    border-bottom: none !important


//.no-top-radius
//  border-top-left-radius: unset !important
//  border-top-right-radius: unset !important
//  border-bottom-left-radius: unset !important

</style>